export var SectionStatus;
(function (SectionStatus) {
    SectionStatus[SectionStatus["inCart"] = 0] = "inCart";
    SectionStatus[SectionStatus["pending"] = 1] = "pending";
    SectionStatus[SectionStatus["registered"] = 2] = "registered";
    SectionStatus[SectionStatus["denied"] = 3] = "denied";
})(SectionStatus || (SectionStatus = {}));
